import { useEffect } from 'react';

import { SnackbarType } from '@/contexts/Snackbar/SnackbarType';
import useSnackbar from '@/hooks/useSnackbar';
import useTranslation from '@/hooks/useTranslation';
import { subscribeToRequestFeedback } from '@/utils/requestFeedback';

const PERMISSION_DENIED_DEDUPE_KEY = 'terminal-permission-denied';

export function RequestFeedbackBridge() {
  const { open } = useSnackbar();
  const t = useTranslation('common');

  useEffect(
    () =>
      subscribeToRequestFeedback((event) => {
        if (event.type === 'permission-denied') {
          open({
            title: t('permission.denied-title'),
            message: t('permission.denied-message'),
            type: SnackbarType.Error,
            dedupeKey: PERMISSION_DENIED_DEDUPE_KEY,
            dedupeWindowMs: 5_000,
          });
        }
      }),
    [open, t]
  );

  return null;
}
